import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import Header from "../../components/global/Header";
import PricingComponent from "../../components/subscriberComponents/PricingComponent";
import axios from "axios";

const Buttons = {
  nonsubscribed: {
    buttonText: "Buy this plan",
  },
  subscribed: {
    buttonText: "Current Subscription",
  },
};

function ViewPlan({ isSubscribe }) {
  const [allTiers, setAllTiers] = useState([]);

  useEffect(() => {
    const GetPlans = async () => {
      try {
        const response = await axios.get(
          "http://127.0.0.1:8000/admins/get-all-plan"
        );

        if (response.status === 200) {
          const modifiedPlans = response.data.plans.map((plan, index) => {
            let additionalDescription = "";
            if (index === 0) {
              additionalDescription = ", No real Transactions";
            } else {
              additionalDescription = ", Real Transactions";
            }
            const descriptionArray = (
              plan.Plan_Feature + additionalDescription
            ).split(", ");
            return {
              id: plan.Plan_id,
              title: plan.Plan_Title,
              subTitle: plan.Plan_subHeader,
              price: plan.Plan_Price,
              accountType: plan.AccountType,
              description: descriptionArray,
              isSubscribed: true,
            };
          });
          setAllTiers(modifiedPlans);
        } else {
          console.error("Error:", response.data);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    GetPlans();
    return () => {
      // Cleanup code, if needed
    };
  }, []);

  return (
    <>
      {isSubscribe == true ? (
        <Box m={"2vw"}>
          <Header
            title={"Subscription Plan"}
            subTitle={"Currently Subscribed Plan"}
          />
          <PricingComponent buttons={Buttons} tiers={allTiers} />
        </Box>
      ) : (
        <Box m="2vw">
          <Header subTitle="No Access" />
        </Box>
      )}
    </>
  );
}

export default ViewPlan;
